"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AutoflowTaskConsole () {
        return AutoflowTaskConsole;
    },
    get AutoflowTaskConsoleBase () {
        return AutoflowTaskConsoleBase;
    },
    get AutoflowTaskConsoleLog () {
        return AutoflowTaskConsoleLog;
    },
    get AutoflowTaskConsoleLogResponse () {
        return AutoflowTaskConsoleLogResponse;
    }
});
const _zod = require("zod");
const _taskbase = require("./task-base");
const AutoflowTaskConsoleBase = _taskbase.AutoflowTaskBase.extend({
    task_type: _zod.z.literal("console:"),
    config: _taskbase.AutoflowTaskConfigBase
});
const AutoflowTaskConsoleLog = AutoflowTaskConsoleBase.extend({
    task_type: _zod.z.literal("console:log"),
    config: _taskbase.AutoflowTaskConfigBase.extend({
        template: _zod.z.string(),
        header: _zod.z.string().optional(),
        footer: _zod.z.string().optional(),
        params: _zod.z.record(_zod.z.string()).optional()
    })
});
const AutoflowTaskConsoleLogResponse = _taskbase.AutoflowTaskBaseResponse.merge(AutoflowTaskConsoleLog).extend({
    outputs: _zod.z.array(_zod.z.string())
});
const AutoflowTaskConsole = _zod.z.discriminatedUnion("task_type", [
    AutoflowTaskConsoleBase,
    AutoflowTaskConsoleLog
]);
